import React, { useEffect, useRef, useState } from 'react';
import { StyledGridShelfzone } from './StyledGridShelfzone';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const GridShelfzone = () => {
 

  useEffect(() => {
    const animImgs = document.querySelectorAll('.anim-img');
    for(var i = 0; i < animImgs.length; i++){

      gsap.to(animImgs[i], {
        duration: .75,
        ease: "power2.easeInOut",
        scale: 1.1,
        scrub: 1,
        scrollTrigger: {
          trigger: animImgs[i],
          start: "top center"
        }
      })

    }
   

  }, [])

  return (
    <React.Fragment>
      {
       
          <StyledGridShelfzone>
            <div className="grid--shelfzone">
              <div className="center--paragraph">
                <p className="preset-13 intro-title">USE CASES</p>
                <h6 className="md--title">Steps Shelfzone takes to help you pave a path to success</h6>
              </div>
              <div className="grid-wrap--shelfzone">
                <div className="grid-row--shelfzone">
                  <div className="grid-col--shelfzone grid-col-text--shelfzone">
                    <p className="preset-10 number">01</p>
                    <h6 className="md--title">Build</h6>
                    <p className="preset-11">Design, and redesign, every detail of your current business or future business plans in VR - from simulating projects, activities, and displays to conducting faster, more frequent, and fully-optimized store and layout revisions.</p>
                  </div>
                  <div className="grid-col--shelfzone">
                    <img className="anim-img" src={require('../../assets/shelfzone-slider/slide-1.jpg')} />
                  </div>
                </div>
                <div className="grid-row--shelfzone grid-reverse">
                  <div className="grid-col--shelfzone">
                    <img className="anim-img" src={require('../../assets/shelfzone-slider/slide-2.jpg')} />
                  </div>
                  <div className="grid-col--shelfzone grid-col-text--shelfzone">
                    <p className="preset-10 number">02</p>
                    <h6 className="md--title">Test</h6>
                    <p className="preset-11">Conduct shopper research with advanced technologies to gain deeper insights, validate projects before their physical implementation, and eliminate mistakes and errors, while simultaneously evaluating all options and opportunities and accelerating your go-to-market timeline.</p>
                  </div>
                </div>
                <div className="grid-row--shelfzone">
                  <div className="grid-col--shelfzone grid-col-text--shelfzone">
                    <p className="preset-10 number">03</p>
                    <h6 className="md--title">Showcase</h6>
                    <p className="preset-11">Engage any audience with project results, through 4K screens or pixel streaming, to exhibit different configurations in real-time and customize them with one click, all while helping foster seamless collaboration with your partners and colleagues.</p>
                  </div>
                  <div className="grid-col--shelfzone">
                    <img className="anim-img" src={require('../../assets/shelfzone-slider/slide-3.jpg')} />
                  </div>
                </div>
              </div>
              
            </div>
            
          </StyledGridShelfzone>
          
      }
    </React.Fragment>
  );
};



export default GridShelfzone;
